import { render, staticRenderFns } from "./TinymceEdit.vue?vue&type=template&id=504e7371&"
import script from "./TinymceEdit.vue?vue&type=script&lang=js&"
export * from "./TinymceEdit.vue?vue&type=script&lang=js&"
import style0 from "./TinymceEdit.vue?vue&type=style&index=0&id=504e7371&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports